// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2gIRf","header":"ReportDetails_header__u6l1X","title":"ReportDetails_title__2AqI7","left":"ReportDetails_left__3nLb1"};